import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

// 从 localStorage 读取语言设置
const savedLocale = localStorage.getItem('vuestic-locale')
let appLocale = 'cn'
if (savedLocale && (savedLocale === 'cn' || savedLocale === 'gb')) {
  appLocale = savedLocale
  i18n.global.locale.value = savedLocale
} else {
  // 如果没有保存的语言设置，默认使用中文
  i18n.global.locale.value = 'cn'
  localStorage.setItem('vuestic-locale', 'cn')
}

console.log('🌍 App locale set to:', appLocale)

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(
  createVuestic({
    config: vuesticGlobalConfig,
    locale: appLocale,
  }),
)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
